import { render, staticRenderFns } from "./fakeSquare.vue?vue&type=template&id=9e3b4f92&scoped=true&"
import script from "./fakeSquare.vue?vue&type=script&lang=js&"
export * from "./fakeSquare.vue?vue&type=script&lang=js&"
import style0 from "./fakeSquare.vue?vue&type=style&index=0&id=9e3b4f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3b4f92",
  null
  
)

export default component.exports